import {useEffect} from "react";
import {useSelector} from "react-redux";
import {ApplicationState} from "../store";
import {SettingsState} from "../store/settings/types";

const useObjectFitElement = (ref: React.RefObject<HTMLImageElement | HTMLVideoElement>) => {
    const { paneIsResponsive } = useSelector<ApplicationState, SettingsState>(state => state.settings);

    useEffect(() => {
        if (ref.current) {
            const objectFitStyle = paneIsResponsive ? 'fill' : 'contain';
            ref.current.classList.remove('contain');
            ref.current.classList.remove('fill');
            ref.current.classList.add(objectFitStyle);
        }
    })
};

export default useObjectFitElement